/**
 * Legacy timeline nav (production TimelineSection) for sections/timeline-prev.liquid.
 * Scoped to [data-section-type="timeline-prev"] — does not affect native timeline-carousel.
 */
(function () {
  if (window.__mauTimelinePrevBundle) return;
  window.__mauTimelinePrevBundle = true;
  function selectNavAndItem(sectionRoot, navButton) {
    const items = Array.from(sectionRoot.querySelectorAll('.Timeline__Item'));
    const idx = parseInt(navButton.getAttribute('data-index'), 10);
    const newItem = items[idx];
    if (!newItem || navButton.classList.contains('is-selected')) return;

    const navWrapper = navButton.parentElement;
    if (navWrapper && navWrapper.scrollWidth > navWrapper.clientWidth) {
      const visibleWidth = navWrapper.clientWidth;
      const beginBound = navButton.offsetLeft;
      const endBound = beginBound + navButton.offsetWidth;
      const closerToLeft = beginBound <= visibleWidth - endBound;
      const itemToUse = closerToLeft
        ? navButton.previousElementSibling || navButton
        : navButton.nextElementSibling || navButton;

      let scrollableOffset = 0;
      const itemBeginBound = itemToUse.offsetLeft - navWrapper.scrollLeft;
      const itemEndBound = itemBeginBound + itemToUse.offsetWidth;

      if (itemEndBound > visibleWidth) {
        scrollableOffset = itemEndBound - visibleWidth;
      } else if (itemBeginBound < 0) {
        scrollableOffset = itemBeginBound;
      }

      navWrapper.scrollBy({ behavior: 'smooth', left: scrollableOffset });
    }

    sectionRoot.querySelectorAll('.Timeline__NavItem').forEach(function (btn) {
      btn.classList.toggle('is-selected', btn === navButton);
    });
    sectionRoot.querySelectorAll('.Timeline__Item').forEach(function (item) {
      item.classList.toggle('is-selected', item === newItem);
    });
  }

  function onNavClick(sectionRoot, event) {
    const target = event.target.closest('.Timeline__NavItem');
    if (!target || !sectionRoot.contains(target)) return;
    event.preventDefault();
    selectNavAndItem(sectionRoot, target);
  }

  const roots = new WeakMap();

  function init(sectionRoot) {
    if (!sectionRoot || roots.has(sectionRoot)) return;
    const handler = onNavClick.bind(null, sectionRoot);
    sectionRoot.addEventListener('click', handler, true);
    roots.set(sectionRoot, handler);
  }

  function destroy(sectionRoot) {
    const handler = roots.get(sectionRoot);
    if (handler) {
      sectionRoot.removeEventListener('click', handler, true);
      roots.delete(sectionRoot);
    }
  }

  function initAllInDocument() {
    document.querySelectorAll('[data-section-type="timeline-prev"]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAllInDocument);
  } else {
    initAllInDocument();
  }

  document.addEventListener('shopify:section:load', function (event) {
    const root = event.target.querySelector('[data-section-type="timeline-prev"]');
    if (root) init(root);
  });

  document.addEventListener('shopify:section:unload', function (event) {
    const root = event.target.querySelector('[data-section-type="timeline-prev"]');
    if (root) destroy(root);
  });

  document.addEventListener('shopify:block:select', function (event) {
    const detail = event.detail;
    if (!detail || !detail.blockId) return;
    const sectionHost = event.target;
    const blockEl =
      (sectionHost && sectionHost.querySelector
        ? sectionHost.querySelector('#shopify-block-' + detail.blockId)
        : null) || document.querySelector('#shopify-block-' + detail.blockId);
    if (!blockEl) return;
    const item = blockEl.closest('.Timeline__Item');
    if (!item) return;
    const sectionRoot = item.closest('[data-section-type="timeline-prev"]');
    if (!sectionRoot) return;
    const idx = item.getAttribute('data-index');
    const navBtn = sectionRoot.querySelector('.Timeline__NavItem[data-index="' + idx + '"]');
    if (navBtn) selectNavAndItem(sectionRoot, navBtn);
  });
})();
